// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"229":"ba872b72","387":"bb7ce721","507":"78211d06","578":"1734b0aa","725":"06c5f959","828":"c7d87ef7","857":"2410afd7"}[chunkId] + ".chunk.js";
};